import { Card, IconButton } from "@mui/material";
import { Slider } from "component/commonComponents/Slider";
import { IThemeProps } from "component/theme";
import styled from "styled-components";

export const MajorOutageCardStyle = styled(Card)<{isShowSlideBtn: boolean, showOutageEyebrow: boolean}>`
  ${({ theme, isShowSlideBtn, showOutageEyebrow }: IThemeProps & any) => `
    height: ${isShowSlideBtn ? (showOutageEyebrow ? "115px" : "90px") : (showOutageEyebrow ? "95px" : "70px")};
    background-color: ${theme.uptimeColors?.majorOutageCard?.background} !important;
    border-radius: 10px !important;
    ${showOutageEyebrow && "display: flex; align-items: center;"}
    &:hover {
      border-color: transparent;
      box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
        0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
    }
`}
`;

export const StyledSlider = styled(Slider)`
${({ theme }) => `
  .slick-dots {
    padding: 8px 0;
    position: absolute;
    justify-content: center;
    align-items: center;
    display: flex;
    bottom: -5px !important;
  };
  .slick-dots li button:before {
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    font-size: 4px;
    line-height: 4px;
    color: black;
    position: initial;
  };
  .slick-dots li.slick-active {
    background: rgba(0, 0, 0, 0.08);
  }
  &.slick-slider, .slick-list, .slick-track,  .slick-slide, .slick-slide > div:first-child {
    height: 100%;
    width: 100%;
  }
  `}
`;

export const StyledButton = styled(IconButton)`
  &.MuiIconButton-root {
    border-radius: 4px;
    padding: 0px;
  }
`;